var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9535 9.34881L13.9535 12.8599L1.04651 12.8599L1.04651 9.34881C1.04651 9.05928 0.81279 8.82556 0.523256 8.82556C0.233721 8.82556 -2.11873e-07 9.05928 -1.99217e-07 9.34881L-2.28722e-08 13.3831C-1.02163e-08 13.6727 0.233721 13.9064 0.523256 13.9064L14.4767 13.9064C14.7663 13.9064 15 13.6727 15 13.3831L15 9.34881C15 9.05928 14.7663 8.82556 14.4767 8.82556C14.1872 8.82556 13.9535 9.05928 13.9535 9.34881Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9767 0.524921L6.9767 6.78829L5.46275 6.78829C5.27089 6.78829 5.09298 6.89469 5.00229 7.06387C4.91159 7.23306 4.92031 7.43887 5.0267 7.59934L7.06217 10.6918C7.1581 10.8383 7.3238 10.9272 7.49996 10.9272C7.67612 10.9272 7.84008 10.8383 7.93775 10.6918L9.97322 7.59934C10.0308 7.51213 10.0587 7.41271 10.0587 7.31155C10.0587 7.22608 10.0378 7.14062 9.99589 7.06387C9.90519 6.89469 9.72729 6.78829 9.53543 6.78829L8.02322 6.78829L8.02322 0.523176C8.02322 0.233641 7.78949 -7.92795e-05 7.49996 -7.92669e-05C7.21043 -7.92542e-05 6.9767 0.235386 6.9767 0.524921Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.44e500fcfdaa97c43a01f512699a2eae.svg";
export { ForwardRef as ReactComponent };